define('modules/start/products/base/view',['require','exports','module','views/BaseView','ldsh!./template'],function (require, exports, module) {
  "use strict";

  var BaseView = require("views/BaseView");

  var Layout = BaseView.extend({
    PRODUCT_STANDARD: 'standard',

    template: require("ldsh!./template"),

    initialize: function () {
      if (this.productDetailsModel) {
        this.listenTo(this.productDetailsModel, "reset sync request error", this.render);
      }
    },

    beforeRender: function () {
      this.insertLogoButtonView();
      if (this.active) {
        this.insertActivityView();
        if (this.isAdm) {
          this.insertStatusView();
        }
      } else {
        this.insertInfoView();
      }
    },

    serialize: function () {
      var templateParams = {
        productsReport: this.productsReport || null,
        productDetails: this.productDetails || null,
        productType: this.PRODUCT_STANDARD,
        active: this.active || false,
        productId: this.productDetailsModel.id || null,
        listDetails: this.listDetails || null
      };

      return templateParams;
    },

    insertLogoButtonView: function () {
      var companyId = this.product.getCompanyIdRedirect(this.selectedCompany);
      var activeinAnyCompany = this.product.anyCompanyIsActive();

      var logoButtonView = new this.LogoButtonView({
        active: this.active,
        groupId: this.groupId,
        companyId: companyId,
        activeinAnyCompany: activeinAnyCompany,
        product: this.product,
        products: this.products,
        productDetails: this.productDetailsModel,
        me: this.me,
        servicePlan: this.servicePlan
      });
      this.insertView(".product-logobutton", logoButtonView);
    },

    insertActivityView: function () {
      var activityView = new this.ActivityView({
        productsReport: this.productsReport,
        productDetails: this.productDetailsModel,
        isAdm: this.isAdm
      });
      this.insertView(".product-activity", activityView);
    },

    insertStatusView: function () {
      var statusView = new this.StatusView({
        productDetails: this.productDetailsModel,
        servicePlan: this.servicePlan
      });
      this.insertView(".product-status", statusView);
    },

    insertInfoView: function () {
      var infoView = new this.InfoView({
        productDetails: this.productDetailsModel,
        servicePlan: this.servicePlan
      });
      this.insertView(".product-info", infoView);
    },

    loadData: function () {
      if (
          (this.active && this.isAdm && !this.productsReport.isRequest) ||
          (this.product.get('name') === 'Transaccionales')
      ) {
        this.productDetailsModel.set('companyId', this.selectedCompany);
        this.productDetailsModel.set('groupId', this.groupId);
        this.productDetailsModel.fetch();
      }
    }
  });

  module.exports = Layout;
});

